import { motion } from "framer-motion";
import { CandlestickChart, Github, LineChart } from "lucide-react";

export default function Nav() {
  return (
    <motion.nav
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="sticky top-0 z-40 glass border-x-0 border-t-0"
      data-testid="top-nav"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-8 w-8 rounded-lg bg-[#00E5FF]/12 border border-[#00E5FF]/30 flex items-center justify-center">
            <CandlestickChart className="h-4 w-4 text-[#00E5FF]" strokeWidth={2.2} />
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-display text-sm font-semibold tracking-tight">PsychLevel</span>
            <span className="font-mono text-[10px] text-white/45 tracking-widest">NSE · EQUITY · 1H</span>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-8">
          <a href="#scanner" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="nav-scanner">Scanner</a>
          <a href="#backtest" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="nav-backtest">Backtest</a>
          <a href="#alerts" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="nav-alerts">Alerts</a>
          <a href="#methodology" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="nav-methodology">Methodology</a>
          <a href="/screener" className="text-sm text-[#00E5FF] hover:text-white transition-colors font-medium" data-testid="nav-chartink">Chartink Screener →</a>
        </div>
        <a href="#scanner" className="pill-btn text-sm inline-flex items-center gap-2" data-testid="nav-cta">
          <LineChart className="h-4 w-4" /> Open Terminal
        </a>
      </div>
    </motion.nav>
  );
}
